<template>
  <div class="card shadow-sm">
    <div class="d-flex w-100 p-3 justify-content-between mt-1 border-bottom position-relative card-title-ido">
      <h5 class="fw-bold text-primary">设备使用趋势</h5>
      <div class="btn-group">
        <button class="btn btn-outline-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          {{currentY}}年
        </button>
        <ul class="dropdown-menu" style="width: 80px !important;min-width: 80px !important;">
          <li v-for="y of yearList" :key="y">
            <a class="dropdown-item point-curser" :class="{'active':currentY==y}" @click="changeY(y)">
              {{y}}年
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="list-box mt-2">
      <!--              数据-->
      <div class="d-flex w-100 p-2 justify-content-between flex-shrink-0 dom-chat-box" ref="chart">

      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref, defineExpose, onUnmounted,onBeforeUnmount} from "vue";
import {getListMock} from "@/api/test";
import * as echarts from 'echarts'
const yearList = ref([])
const currentY = ref()

const chart = ref()
let mychart = null
let options = {
  color: ['#0F7EF9','#90ca74'],
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    }
  },
  grid: {
    left: 60,
    right: '4%',
    top: 40,
    bottom: 50,
    // right: '4%',
    // bottom: '3%',
    // containLabel: true
  },
  legend:{
    itemWidth: 30,
    itemHeight: 15,
    right: 10
  },
  xAxis: [
    {
      type: 'category',
      axisLabel: {
        show: true,
        textStyle: {
          color: '#000'
        }
      },
      axisLine: {
        show:true,
        onZero:true,
        symbol:"none",
        lineStyle: {
          color: 'rgba(0, 0, 0, 1)',
          width: 1
        }
      },
      boundaryGap: false,
      splitLine: {
        show: false
      },
      axisTick:false,
      data: ["0","1","2","3","4","5","6"],
    }
  ],
  yAxis: [
    {
      type: 'value',
      name: "次", //坐标名字
      nameLocation: "end",//坐标位置，支持start,end，middle
      axisLabel: {
        show: true,
        textStyle: {
          color: '#000'
        },
        // formatter: '{value} 次'
      },
      axisLine: {
        show:true,
        onZero:true,
        lineStyle: {
          color: 'rgba(0, 0, 0, 1)', // color: 'rgba(6, 145, 254, 0.3)',
          width: 1
        }
      },
      axisTick:false,
      splitLine: {
        show: false
      },
    },

  ],
  series: [
    {
      name: '预约趋势',
      type: 'line',
      smooth: true,
      symbol: 'none',
      itemStyle: {
        normal: {
          // color: '#fff',
          fontSize: 14,
          lineStyle: {
            width: 3, //折线宽度
            //折线颜色渐变
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
              offset: 0,
              color: 'rgba(45,105,249,1)'
            },
              {
                offset: 1,
                color: 'rgba(89,205,253,1)'
              }])
          }
        }
      },
      // areaStyle: {
      //   color: 'rgba(46,82,212,0.2)'    //折线区域的背景颜色
      // },
      stack: 'stack',
      data: [11, 21, 300, 31, 403, 11, 12]
    },
    {
      name: '使用趋势',
      type: 'line',
      smooth: true,
      symbol: 'none',
      itemStyle: {
        normal: {
          // color: '#fff',
          fontSize: 14,
          lineStyle: {
            width: 3, //折线宽度
            //折线颜色渐变
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
              offset: 0,
              color: 'rgb(144,202,116)'
            },
              {
                offset: 1,
                color: 'rgb(133,201,141)'
              }])
          }
        }
      },
      // areaStyle: {
      //   color: 'rgba(46,82,212,0.2)'    //折线区域的背景颜色
      // },
      stack: 'stack2',
      data: [10, 2, 30, 30, 203, 5, 6]
    },
  ]
};
onMounted(()=>{
  getyearList() // 初始化年列表
  initChat()
  window.addEventListener('resize', onwindowresize, false)
})
onBeforeUnmount(()=>{
  if (mychart != null && mychart.dispose) {
    mychart.dispose();
  }
})
onUnmounted(()=>{
  window.removeEventListener('resize', onwindowresize)
  if (mychart != null && mychart.dispose) {
    mychart.dispose();
  }
})
// 初始化年列表
const getyearList = ()=>{
  const y = []
  const year = currentY.value = new Date().getFullYear()
  for(let i=0;i<5;i++){
    y.push(year-i)
  }
  yearList.value = y
}
const changeY = (y)=>{
  currentY.value = y
}
// 初始化
const initChat =async ()=>{
  mychart = echarts.init(chart.value)
  mychart && mychart.showLoading()
  await getListMock()
  mychart && mychart.hideLoading()
  mychart && mychart.setOption(options)
}

const onwindowresize = ()=>{
  if (mychart) {
    mychart.resize()
  }
}
const resetChatData = (data)=>{
  options.series.data = data
  mychart && mychart.setOption({
    series:{
      data:data
    }
  })
}
defineExpose({
  resetChatData
})

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/css/FirstPageListStyle.scss";
</style>
